import cn from 'classnames';
import { GENERIC_ERROR_EVENT } from 'core-lib/constants/common';
import { useEffect } from 'react';
import { Typography } from 'ui-v2/components/Typography';
import s from './ToastComp.module.scss';

interface ToastCompProps {
  leftIcon?: any;
  rightIcon?: any;
  label: string;
  isVisible: boolean;
}

export const ToastComp: React.FunctionComponent<ToastCompProps> = ({
  leftIcon,
  rightIcon,
  label,
  isVisible,
}) => {
  useEffect(() => {
    return () => {
      window.removeEventListener(GENERIC_ERROR_EVENT, () => {});
    };
  }, []);
  return (
    <div
      className={cn('cmn_toast_container', s.container, {
        [s.bottom]: !isVisible,
      })}
    >
      <div className={s.leftIcon}>{leftIcon}</div>
      <div className={s.msg}>
        <Typography
          variant='body_4_medium'
          color='on_dark_bg'
          label={label}
          // style={{
          //   whiteSpace: 'nowrap',
          //   overflow: 'hidden',
          //   textOverflow: 'ellipsis',
          // }}
        />
      </div>
      <div className={s.rightIcon}>{rightIcon}</div>
    </div>
  );
};
